import { useEffect, useState } from "react";
//---------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import { MyFormData, myAxios } from "src/components/common/functions";
import WorkLogForm from "../workLogForm";
//---------------------------------------------------
export default function SacromentoVacuumFieldSurvey({
    ...rest
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [ready, setReady] = useState(false);
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            const formData = new MyFormData();
            formData.append("userEmail", rest.labor);
            setShowLoader(true);
            const res = await myAxios("common/getPhoneNumber.php", formData);
            if(!isMounted) return;
            setShowLoader(false);
            if(!res) return;
            setPhoneNumber(res.data);
            setReady(true);
        }
        getData();
        return () => {isMounted = false;}
    }, [])
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Company Name", type: "text", default: "Bess TestLab", readOnly: true, required: true},
        {title: "Driver Name", type: "text", default: rest.userName, readOnly: true, required: true},
        {title: "Driver Phone Number", type: "text", default: phoneNumber, required: true},
        {title: "Job Number", type: "text", default: rest.projectName, readOnly: true, required: true},
        {title: "Material", type: "select", options: ["wet", "mix"], required: true},
        {title: "Address", type: "text", default: "5305 Excelsior Rd, Sacramento, CA, 95827", readOnly: true, required: true}
    ];
    //--------------------------------------------------------------------------------------------
    return(
        ready?<WorkLogForm
            items = {items}
            {...rest}
        />:<></>
    )    
}